import _defineProperty from '@babel/runtime/helpers/defineProperty';
import styled, { css } from 'styled-components';
import { siteThemes, theme } from '../../utils/theming.js';
import { focusOutline } from '../../utils/mixins.js';

var DEFAULT = siteThemes.DEFAULT,
  GLOBETROTTER = siteThemes.GLOBETROTTER;
var borderColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, 'var(--color-grey-400)'), GLOBETROTTER, 'var(--color-cta-button-primary)'));
var hoverColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, 'var(--color-grey-600)'), GLOBETROTTER, 'var(--color-cta-button-primary-hover)'));
var RadioButton = styled.div.withConfig({
  displayName: "style__RadioButton",
  componentId: "sc-q4nulc-0"
})(["display:flex;flex-direction:row;", ""], function (props) {
  return !props.children && css(["display:inline-block;"]);
});
var Circle = styled.span.withConfig({
  displayName: "style__Circle",
  componentId: "sc-q4nulc-1"
})(["align-items:center;background:var(--color-white);border:0.2rem solid ", ";border-radius:100%;display:inline-flex;flex-shrink:0;height:2.4rem;justify-content:center;position:relative;transition:background var(--transition),border var(--transition);width:2.4rem;@media (min-resolution:192dpi){border-width:0.15rem;}", " ", " ", " ", " ", ":hover &{", "}", " ", ""], borderColor, function (props) {
  return props.$disabled && css(["background:var(--color-background-disabled);border-color:var(--color-border-disabled);"]);
}, function (props) {
  return props.$disabledSelected && css(["background:var(--color-background-disabled);border-color:var(--color-border-disabled);&::before{background:var(--color-border-disabled) !important;height:0.8rem !important;width:0.8rem !important;}"]);
}, function (props) {
  return props.$invalid && !props.$disabled && css(["background:var(--color-white);border-color:var(--color-element-input-error);"]);
}, function (props) {
  return props.$checked && !props.$disabled && css(["background:var(--color-cta-button-primary);border-color:var(--color-cta-button-primary);"]);
}, RadioButton, function (props) {
  return !props.$checked && css(["border-color:", ";"], hoverColor);
}, function (props) {
  return props.theme.site === GLOBETROTTER && css(["&:before{position:absolute;border:0.1rem solid var(--color-white);border-radius:100%;content:'';height:1.8rem;width:1.8rem;@media (min-resolution:192dpi){border-width:0.15rem;}}"]);
}, function (props) {
  return props.theme.site !== GLOBETROTTER && css(["&::before{background:var(--color-white);border-radius:100%;content:'';height:0.6rem;transition:background var(--transition);width:0.6rem;", "}"], props.$disabled && !props.$checked && css(["display:none;"]));
});
var Input = styled.input.withConfig({
  displayName: "style__Input",
  componentId: "sc-q4nulc-2"
})(["display:inline;opacity:0;height:0;width:0;"]);
var Label = styled.label.withConfig({
  displayName: "style__Label",
  componentId: "sc-q4nulc-3"
})(["align-items:center;cursor:pointer;display:flex;user-select:none;", " ", ":focus-visible + &{", "}"], function (props) {
  return props.$disabled && css(["opacity:0.6;cursor:default;"]);
}, Input, focusOutline);
var LabelContent = styled.span.withConfig({
  displayName: "style__LabelContent",
  componentId: "sc-q4nulc-4"
})(["display:inline-block;font-family:var(--font-family-body);font-size:1.6rem;line-height:2.4rem;padding-left:10px;"]);

export { Circle, Input, Label, LabelContent, RadioButton };
//# sourceMappingURL=style.js.map
